
// 
// 描述： 跟踪审计接口
// 时间： 2020 / 5 / 28
// created by zjj
// 
import request from '../request.js'

//跟踪审计-解析xml 李开明
const parseXml = function (data, progressFn, index) {
    return request({
        url: 'busTrackAudit/parseXml',
        method: 'post',
        config: {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        },
        onUploadProgress: function (progressEvent) {
            if (progressFn) {
                progressFn(progressEvent, index)
            }
        },
        data
    })
}

//跟踪审计-新增进度款(造价阶段,计价依据）李开明
const newProgressPayment = function (data) {
    return request({
        url: 'busTrackAudit/newProgressPayment',
        method: 'post',
        data
    })
}

//跟踪审计-输入期数判断当前期数是否有数据 李开明
const judgeIsDataByPeriod = function (data) {
    return request({
        url: 'busTrackAudit/judgeIsDataByPeriod',
        method: 'post',
        data
    })
}
//跟踪审计-选择xml文件点击确定跳转页面后，单击单位工程下拉列表判断该单位工 李开明
const judgeAuditIsData = function (data) {
    return request({
        url: 'busTrackAudit/judgeAuditIsData',
        method: 'post',
        data
    })
}
//跟踪审计-保存解析后的xml和申报或批准进度款 李开明
const saveXmlAndPayment = function (data) {
    return request({
        url: 'busTrackAudit/saveXmlAndPayment',
        method: 'post',
        data
    })
}
//跟踪审计-页面回显 李开明
const auditEcho = function (data) {
    return request({
        url: 'busTrackAudit/auditEcho',
        method: 'post',
        data
    })
}
//跟踪审计-期数对比 李开明
const selectPeriodsData = function (data) {
    return request({
        url: 'busTrackAudit/selectPeriodsData',
        method: 'post',
        data
    })
}

//跟踪审计 - 当前申报金额类型 李开明
const getDeclaredType = function (data) {
    return request({
        url: 'busTrackAudit/echoDeclaredType',
        method: 'post',
        data
    })
}

//跟踪审计-列表头部表单 张卫华
const auditEchoHeader = function (data) {
    return request({
        url: 'busTrackAudit/auditEchoHeader',
        method: 'post',
        data
    })
}

// 跟踪审计 -- 自动匹配 ————————（郑志会）
const autoMatchTracking = function (params) {
    return request({
        url: 'busTrackAudit/automaticMatchingTreeId',
        method: 'post',
        data: params,
    })
}

//修改 数据对比时的 保存
const comparePayEdit = function (data) {
    return request({
        url: 'busTrackAudit/savePaymentAmount',
        method: 'post',
        data
    })
}

// 查询自动分析报告中是否有数据 --- 李开明
const checkFileZipIsData = function (data) {
    return request({
        url: 'busTrackAudit/checkFileZipIsData',
        method: 'post',
        data
    })
}


export {
    parseXml,
    auditEcho,
    comparePayEdit,
    newProgressPayment,
    judgeIsDataByPeriod,
    judgeAuditIsData,
    saveXmlAndPayment,
    selectPeriodsData,
    getDeclaredType,
    auditEchoHeader,
    autoMatchTracking,
    checkFileZipIsData
}